import Fetch from 'utils/fetch';

/*******************************************************************************
 *
 *   1. Default State
 *   2. Action Types
 *   3. ACtion Creators
 *   4. Reducers
 *
 */

/*******************************************************************************
 *  1. Default State
 */

const profileState = {
	errorCode: '',
	errorMessage: '',
	commPrefSponsor: '',
	commPrefPromo: ''
};

/*******************************************************************************
 *  2. Action Types
 */
 
const FETCH_PROFILE = 'fetchProfile';
const FETCHED_PROFILE = 'fetchedProfile';

const SEND_PROFILE_DETAILS = "sendProfileDetails";
const UPDATE_PROFILE_DETAILS = "updateProfileDetails";

/*******************************************************************************
 *  3. Action Creators
 */
 
 export const fetchProfile = () => {
 	return ( dispatch ) => {

        return Fetch( {
            url: FEEDS.APP_PROFILE,
            dispatch: dispatch,
            type: FETCH_PROFILE
        } ).then( ( results ) => {
            dispatch( {
                type: FETCHED_PROFILE,
                data: results.data
            } );
            dispatch( results.fetched );
        } );

    };
 };
 
 export const sendProfileDetails = data => {
	return dispatch => {
		return Fetch({
			url: FEEDS.APP_PROFILE_UPDATE,
			method: "POST",
			dispatch: dispatch,
			type: SEND_PROFILE_DETAILS,
			body: data
		}).then(results => {
			dispatch({
				type: UPDATE_PROFILE_DETAILS,
				data: results.data
			});
		dispatch(results.fetched);
		});
	};
};
 

/*******************************************************************************
 *  4. Reducers
 */

export default ( state = profileState, action ) => {

	switch( action.type ) {
		
        case FETCHED_PROFILE:
			return {
                ...state,
                ...action.data,
				errorCode: '',
				errorMessage: '',
				commPrefSponsor: action.data.commPrefSponsor,
				commPrefPromo: action.data.commPrefPromo				
			};
			
		case UPDATE_PROFILE_DETAILS:
			return {
				...state,
				...action.data,
				errorCode: action.data.code,
				errorMessage: action.data.message
			};

		default:
	    	return state;
	}

};



// WEBPACK FOOTER //
// ./src/profile/profile-dux.js